module.exports = __webpack_public_path__ + "img/IMG_9786_L_BlackMatted_MockedUp.c41a70f4.jpg";